import React, { Component } from "react";
import PropTypes from 'prop-types';
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
// services
import userService from "services/user.service";
// util
import Notifications from "views/Notifications/Notifications";

const styles = theme => ({
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    }
});

class DeletarAlunos extends Component {
    constructor(props) {
        super(props);
        this.state = {notification: {show: false, message: '', type: 'info'}};

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event, uid) {
		userService.deleteUser(uid)
		.then(res => this.showNotification('Aluno deletado com sucesso!', 'success'))
		.catch(err => this.showNotification('Ocorreu um erro ao tentar deletar aluno! ' + err, 'danger'));
		event.preventDefault();
    }
    
    showNotification(message, type){
        this.setState({notification: {show: true, message: message, type: type}});
        setTimeout(() => {
            this.setState({notification: {show: false, message: '', type: 'info'}});
            this.props.onClose();
        }, 3000);
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={classes.cardTitleWhite}>Excluir Aluno</h4>
                                <p className={classes.cardCategoryWhite}>Você tem certeza que deseja deletar permanentemente este aluno?</p>
                            </CardHeader>
                            <CardBody>
                                <Button color="primary" type="submit" round onClick={(event) => {this.handleSubmit(event, this.props.uid)}}>Confirmar e excluir</Button>
                            </CardBody>
                        </Card>
                    </GridItem>
                    {(this.state.notification.show === true) ? (<Notifications notification={this.state.notification} />) : null}
                </GridContainer>
            </div>
        );
    };
}

DeletarAlunos.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styles)(DeletarAlunos);